import CheckCircle from "@assets/images/check-circle.svg";
import ChevronDown from "@assets/images/chevron-down-2.svg";
import ChevronUp from "@assets/images/chevron-up-2.svg";
import InfoIcon from "@assets/images/info.svg";
import RefreshIcon from "@assets/images/refresh-primary.svg";
import ErrorIcon from "@assets/images/x-circle.svg";
import {
  Box,
  Button,
  Collapse,
  Divider,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { StatusFilter } from "@saleor/alternatedMaterial/types";
import InputSuggestion from "@saleor/changeOrderExport/components/InputSuggestion";
import DatePicker from "@saleor/components/DatePicker";
import FormSpacer from "@saleor/components/FormSpacer";
import MultipleAutocompleteTextInput from "@saleor/components/MultipleAutocompleteTextInput";
import MyTypography from "@saleor/components/MyTypography";
import { SingleSelectField } from "@saleor/components/SingleSelectField";
import { SingleTextField } from "@saleor/components/SingleTextField";
import {
  AlternatedMaterialFilterInput,
  useFilterSoldToScgCheckoutLazyQuery,
  useSalesOrganizationsQuery,
  useSuggestionSearchUserByNameLazyQuery
} from "@saleor/graphql";
import { mapEdgesToItems } from "@saleor/utils/maps";
import classNames from "classnames";
import { useFormik } from "formik";
import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import SVG from "react-inlinesvg";
import { FormattedMessage, useIntl } from "react-intl";

import useStyles from "./styles";

interface LogChangeFilterProps {
  setFilter?: (value) => void;
  statusFilter?: StatusFilter;
  dataFilter?: any[];
}

const LogChangeFilter: React.FC<LogChangeFilterProps> = ({
  statusFilter,
  setFilter,
  dataFilter
}) => {
  const classes = useStyles();
  const intl = useIntl();
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const [reRender, setRender] = useState<boolean>(false);
  const [isClean, setIsClean] = useState<boolean>(false);

  useEffect(() => {
    if (dataFilter.length) {
      setIsOpen(false);
    }
  }, [dataFilter]);

  const [
    getSoldToDataSuggestions,
    { data: fetchSoldToDataSuggestions, loading: loadingSoldToDataSuggestion }
  ] = useFilterSoldToScgCheckoutLazyQuery();

  const [
    getCreateByDataSuggestions,
    {
      data: fetchCreateByDataSuggestions,
      loading: loadingCreateByDataSuggestion
    }
  ] = useSuggestionSearchUserByNameLazyQuery();

  const { data: saleOriganizationOptions } = useSalesOrganizationsQuery();

  const formik = useFormik({
    initialValues: {
      createBy: "",
      createdDateGte: moment()
        .subtract(3, "month")
        .format("YYYY-MM-DD"),
      createdDateLte: moment().format("YYYY-MM-DD"),
      errorType: "",
      soNo: "",
      poNo: "",
      requestDateGte: moment()
        .subtract(3, "month")
        .format("YYYY-MM-DD"),
      requestDateLte: moment().format("YYYY-MM-DD"),
      saleOrganization: "",
      soldTo: [],
      typeNewMaterial: "",
      newMaterial: "",
      typeOldMaterial: "",
      oldMaterial: ""
    },
    onSubmit: () => {
      //
    }
  });

  const isDisable =
    (formik.values.createdDateLte === null &&
      formik.values.createdDateGte !== null) ||
    (formik.values.createdDateLte !== null &&
      formik.values.createdDateGte === null) ||
    (formik.values.requestDateLte === null &&
      formik.values.requestDateGte !== null) ||
    (formik.values.requestDateLte !== null &&
      formik.values.requestDateGte === null);

  const soldToOptions = useMemo(
    () =>
      (
        mapEdgesToItems(fetchSoldToDataSuggestions?.filterSoldToScgCheckout) ||
        []
      ).map(data => ({
        title: `${data.code} - ${data.name}`,
        value: data.id
      })),
    [fetchSoldToDataSuggestions?.filterSoldToScgCheckout]
  );

  const createByOptions = (
    mapEdgesToItems(fetchCreateByDataSuggestions?.suggestionSearchUserByName) ||
    []
  ).map(data => ({
    title: `${data.firstName} ${data.lastName}`,
    value: data.id
  }));

  const salesOrigazationOption =
    useMemo(() => saleOriganizationOptions?.salesOrganizations || [], [
      saleOriganizationOptions?.salesOrganizations
    ]) || [];
  const saleOrigazationFormat = salesOrigazationOption.map(item => ({
    value: item.value,
    label: item.label
  }));
  saleOrigazationFormat.unshift({ value: "All", label: "All" });

  const errorTypesOption = [
    {
      value: "all",
      label: "All"
    },
    {
      value: "No Material Mapping ",
      label: "No Material Mapping "
    },
    {
      value: "No Contract",
      label: "No Contract"
    },
    {
      value: "Material in ref. contract is unavailable",
      label: "Material in ref. contract is unavailable"
    },
    {
      value: "No Stock OS",
      label: "No Stock OS"
    }
  ];

  const renderMessase = () => {
    let srcImg = null;
    let message = "";
    let classNameMessage = "";
    switch (statusFilter) {
      case StatusFilter.INFO:
        srcImg = InfoIcon;
        message = intl.formatMessage({
          defaultMessage: "กรุณากรอกข้อมูลและกดค้นหา"
        });
        classNameMessage = classes.colorInfo;
        break;
      case StatusFilter.SUCCESS:
        srcImg = CheckCircle;
        message = intl.formatMessage({
          defaultMessage: "พบรายการที่เกี่ยวข้อง"
        });
        classNameMessage = classes.colorSuccess;
        break;
      case StatusFilter.ERROR:
        srcImg = ErrorIcon;
        message = intl.formatMessage({
          defaultMessage: "ไม่พบรายการที่เกี่ยวข้อง"
        });
        classNameMessage = classes.colorError;
        break;
      default:
        srcImg = InfoIcon;
        message = intl.formatMessage({
          defaultMessage: "กรุณากรอกข้อมูลและกดค้นหา"
        });
        break;
    }
    return (
      <Box className={classes.info}>
        <img width={20} src={srcImg} alt="info" className={classes.icon} />
        <MyTypography
          variant="body3"
          align={"center"}
          className={classNameMessage}
        >
          {message}
        </MyTypography>
      </Box>
    );
  };

  const handleResetForm = () => {
    formik.resetForm();
    if (setFilter) {
      setFilter({});
    }
    setIsClean(true);
    setTimeout(() => setIsClean(false));
    setRender(prevState => !prevState);
  };

  const handleSubmitForm = () => {
    const formikValues = formik.values;
    const data: AlternatedMaterialFilterInput = {
      saleOrganization:
        formikValues.saleOrganization === "All"
          ? undefined
          : formikValues.saleOrganization || undefined,
      createBy: formikValues.createBy || undefined,
      soNo: formikValues.soNo || undefined,
      poNo: formikValues.poNo || undefined,
      createdDate: {
        gte: formikValues.createdDateGte || undefined,
        lte: formikValues.createdDateLte || undefined
      },
      requestDate: {
        gte: formikValues.requestDateGte || undefined,
        lte: formikValues.requestDateLte || undefined
      },
      soldTo: formikValues.soldTo.length ? formikValues.soldTo : undefined,
      errorType: formikValues.errorType || undefined,
      oldMaterial:
        formikValues.typeOldMaterial === "material"
          ? formikValues.oldMaterial
          : undefined,
      oldGradeGram:
        formikValues.typeOldMaterial === "grade"
          ? formikValues.oldMaterial
          : undefined,
      newMaterial:
        formikValues.typeNewMaterial === "material"
          ? formikValues.newMaterial
          : undefined,
      newGradeGram:
        formikValues.typeNewMaterial === "grade"
          ? formikValues.newMaterial
          : undefined
    };
    setFilter(data);
  };

  return (
    <>
      <Box className={classes.wrapper}>
        <Grid
          className={classes.header}
          container
          onClick={() => setIsOpen(!isOpen)}
        >
          <MyTypography variant="h6">
            <FormattedMessage defaultMessage="ค้นหา Log Change" />
          </MyTypography>
          {isOpen ? <SVG src={ChevronUp} /> : <SVG src={ChevronDown} />}
        </Grid>
        <Collapse in={isOpen} className={classes.container}>
          <Grid className={classes.searchBox} container spacing={5}>
            <Grid item xs={3}>
              <MyTypography variant={"subtitle3"}>
                {intl.formatMessage({
                  defaultMessage: "Sale Organization"
                })}
              </MyTypography>
              <SingleSelectField
                choices={saleOrigazationFormat}
                value={formik.values.saleOrganization}
                onChange={formik.handleChange}
                name={"saleOrganization"}
              />
            </Grid>
            <Grid item xs={3}>
              <MyTypography variant={"subtitle3"}>
                {intl.formatMessage({
                  defaultMessage: "Create by"
                })}
              </MyTypography>
              <InputSuggestion
                dataOptions={createByOptions}
                fetchDataSuggestions={fetchCreateByDataSuggestions}
                loadingDataSuggestion={loadingCreateByDataSuggestion}
                getDataSuggestions={getCreateByDataSuggestions}
                name={"createBy"}
                placeholder="ค้นหา Create By"
                isClean={isClean}
                handleSelectedSearch={e => {
                  formik.handleChange({
                    target: {
                      name: "createBy",
                      value: e
                    }
                  });
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <MyTypography variant={"subtitle3"}>
                {intl.formatMessage({
                  defaultMessage: "SO No."
                })}
              </MyTypography>
              <SingleTextField
                name={"soNo"}
                value={formik.values.soNo}
                onChange={formik.handleChange}
                placeholder={"ระบุ SO No."}
              />
            </Grid>
            <Grid item xs={3}>
              <MyTypography variant={"subtitle3"}>
                {intl.formatMessage({
                  defaultMessage: "PO No."
                })}
              </MyTypography>
              <SingleTextField
                name={"poNo"}
                value={formik.values.poNo}
                onChange={formik.handleChange}
                placeholder={"ระบุ PO No."}
              />
            </Grid>
            <Grid item xs={6}>
              <MyTypography variant={"subtitle3"}>
                {intl.formatMessage({
                  defaultMessage: "Material"
                })}
              </MyTypography>
              <RadioGroup
                name="typeOldMaterial"
                value={formik.values.typeOldMaterial}
                onChange={formik.handleChange}
                className={classes.radioLine}
              >
                <FormControlLabel
                  key={"material"}
                  value={"material"}
                  control={<Radio />}
                  label={"Material"}
                />
                <FormControlLabel
                  key={"grade"}
                  value={"grade"}
                  control={<Radio />}
                  label={"Grade/Gram"}
                />
                <SingleTextField
                  disabled={!formik.values.typeOldMaterial}
                  name={"oldMaterial"}
                  onChange={formik.handleChange}
                  value={formik.values.oldMaterial}
                  placeholder={"ระบุรหัสสินค้าที่สั่ง"}
                />
              </RadioGroup>
            </Grid>
            <Grid item xs={6}>
              <MyTypography variant={"subtitle3"}>
                {intl.formatMessage({
                  defaultMessage: "New Material "
                })}
              </MyTypography>
              <RadioGroup
                name="typeNewMaterial"
                value={formik.values.typeNewMaterial}
                onChange={formik.handleChange}
                className={classes.radioLine}
              >
                <FormControlLabel
                  key={"material"}
                  value={"material"}
                  control={<Radio />}
                  label={"Material"}
                />
                <FormControlLabel
                  key={"grade"}
                  value={"grade"}
                  control={<Radio />}
                  label={"Grade/Gram"}
                />
                <SingleTextField
                  disabled={!formik.values.typeNewMaterial}
                  name={"newMaterial"}
                  onChange={formik.handleChange}
                  value={formik.values.newMaterial}
                  placeholder={"ระบุรหัสสินค้าทดแทน"}
                />
              </RadioGroup>
            </Grid>
            <Grid item xs={6}>
              <MyTypography variant={"subtitle3"}>
                {intl.formatMessage({
                  defaultMessage: "Create Date"
                })}
              </MyTypography>
              <div className={classes.lineRangeDate}>
                <DatePicker
                  name={"createdDateGte"}
                  value={formik.values.createdDateGte}
                  onChange={formik.handleChange}
                  minDate={moment().subtract(1, "y")}
                  maxDate={moment().add(1, "y")}
                />
                <div>to</div>
                <DatePicker
                  name={"createdDateLte"}
                  value={formik.values.createdDateLte}
                  onChange={formik.handleChange}
                  minDate={moment().subtract(1, "y")}
                  maxDate={moment().add(1, "y")}
                />
              </div>
            </Grid>
            <Grid item xs={6}>
              <MyTypography variant={"subtitle3"}>
                {intl.formatMessage({
                  defaultMessage: "Item Request Date"
                })}
              </MyTypography>
              <div className={classes.lineRangeDate}>
                <DatePicker
                  name={"requestDateGte"}
                  value={formik.values.requestDateGte}
                  onChange={formik.handleChange}
                  minDate={moment().subtract(1, "y")}
                  maxDate={moment().add(1, "y")}
                />
                <div>to</div>
                <DatePicker
                  name={"requestDateLte"}
                  value={formik.values.requestDateLte}
                  onChange={formik.handleChange}
                  minDate={moment().subtract(1, "y")}
                  maxDate={moment().add(1, "y")}
                />
              </div>
            </Grid>
            <Grid item xs={6} className={classes.inputHalf}>
              <MyTypography variant={"subtitle3"}>
                {intl.formatMessage({
                  defaultMessage: "Sold to"
                })}
              </MyTypography>
              <MultipleAutocompleteTextInput
                reRender={reRender}
                headerText={"Sold to ที่เลือก"}
                message={
                  "ไม่มี Sold to ที่เลือกไว้ กรุณากรอกข้อมูลด้านบนเพื่อค้นหา"
                }
                keyFilterApi={"search"}
                name={"soldTo"}
                placeholder={"ค้นหา Sold To"}
                getDataSuggestions={getSoldToDataSuggestions}
                fetchDataSuggestions={fetchSoldToDataSuggestions}
                loadingDataSuggestion={loadingSoldToDataSuggestion}
                dataOptions={soldToOptions}
                handleSelectedSearch={value => {
                  formik.handleChange({
                    target: {
                      name: "soldTo",
                      value: value.length === 0 ? [] : value
                    }
                  });
                }}
                getByValue
              />
            </Grid>
            <Grid item xs={3}>
              <MyTypography variant={"subtitle3"}>
                {intl.formatMessage({
                  defaultMessage: "Error Type"
                })}
              </MyTypography>
              <SingleSelectField
                placeholder={"เลือก Error Type"}
                choices={errorTypesOption}
                name={"errorType"}
                onChange={formik.handleChange}
                value={formik.values.errorType}
              />
            </Grid>
          </Grid>

          <Box className={classes.divider}>
            <FormSpacer />
            <Divider />
          </Box>

          <Box className={classes.bottomBar} ml={3}>
            {renderMessase()}
            <Box className={classes.flex}>
              <Box mr={2}>
                <Button
                  disabled={isDisable}
                  className={classNames(
                    classes.actionButton,
                    isDisable && classes.disableBtn
                  )}
                  variant={"outlined"}
                  color={"secondary"}
                  onClick={handleResetForm}
                >
                  <SVG src={RefreshIcon} width={24} height={24} />
                  <FormattedMessage defaultMessage="ล้างข้อมูล" />
                </Button>
              </Box>
              <Box>
                <Button
                  disabled={isDisable}
                  className={classes.actionButton}
                  variant={"contained"}
                  color={"secondary"}
                  onClick={handleSubmitForm}
                >
                  <SearchIcon style={{ fontSize: "2.4rem" }} />
                  <FormattedMessage defaultMessage="ค้นหา" />
                </Button>
              </Box>
            </Box>
          </Box>
        </Collapse>
      </Box>
    </>
  );
};

export default LogChangeFilter;
